import * as Phaser from "phaser-ce"
import { COLOR } from "../../common/Color"
import { FontType } from "../../common/TextUtils"
import { GameState } from "../GameState"
import { Buttons } from "../generic-sprites/Buttons"
import { Audio } from "./Audio"
import { PhaserText } from "./PhaserText"
import { Scale } from "./Scale"
import { Sprites } from "./Sprites"
import { Videos } from "./Videos"

export class Testimonials {
    static showTestimonials = (
        game: Phaser.Game,
        info: TestimonialOutroInfo,
        promptText: string,
    ) => {
        let testimonialsEnabled = false

        let thumbnailX = null
        let thumbnailY = null

        const prompt = PhaserText.create(game, promptText, {
            x: 20,
            y: 50,
            type: FontType.BODY,
            color: COLOR.white,
            wordWrapWidth: 0.4,
        })

        Audio.add(game, info.testimonialIntroAudio, {
            onStop: () => {
                testimonialsEnabled = true
            },
        })

        info.testimonials.forEach((testimonial, index) => {
            const thumbnail = game.add.button(
                thumbnailX,
                thumbnailY,
                testimonial.thumbnail,
            )
            Scale.scaleToFitTwoVerticallyAndFourHorizontally(thumbnail)

            if (!thumbnailX && !thumbnailY) {
                thumbnailX = Scale.availableWidth() / 2
                if (info.testimonials.length > 2) {
                    thumbnailY = Scale.availableHeight() / 2 - thumbnail.height
                } else {
                    thumbnailY =
                        Scale.availableHeight() / 2 - thumbnail.height / 2
                }
                thumbnail.x = thumbnailX
                thumbnail.y = thumbnailY
            }

            if (index === 0 || index === 2) {
                thumbnailX += thumbnail.width
            } else if (index === 1) {
                thumbnailY += thumbnail.height
                thumbnailX -= thumbnail.width
            }

            thumbnail.onInputDown.add(async () => {
                if (testimonialsEnabled) {
                    testimonialsEnabled = false

                    Sprites.fade(prompt, { fadeIn: false })
                    const video = await Videos.add(game, testimonial.video, {
                        scale: 1.4,
                        centerVertically: true,
                        centerInLeftHalf: true,
                        onComplete: () => {
                            video.destroy()
                            testimonialsEnabled = true
                            testimonial.watched = true
                            let allWatched = true
                            for (const innerTest of info.testimonials) {
                                if (!innerTest.watched) {
                                    allWatched = false
                                }
                            }
                            if (allWatched) {
                                Buttons.create(
                                    game,
                                    "Next",
                                    () => {
                                        Testimonials.startNextState(game, info)
                                    },
                                    {
                                        x: Scale.x(0.2),
                                        y: Scale.y(0.9),
                                    },
                                )
                                testimonialsEnabled = false
                            } else {
                                Sprites.fade(prompt, { fadeIn: true })
                            }
                        },
                    })
                }
            })
        })
    }

    private static startNextState = (
        game: Phaser.Game,
        info: TestimonialOutroInfo,
    ) => {
        if (info.goTo) {
            game.state.start(info.goTo)
        }
        if (info.runOnNext) {
            info.runOnNext()
        }
    }
}

export async function addVideoGroup(
    game: Phaser.Game,
    outroInfo: TestimonialOutroInfo,
    videoKey,
) {
    const videoGroup = game.add.group()
    await Videos.add(game, videoKey, {
        onComplete: () => {
            Buttons.create(
                game,
                "Next",
                () => {
                    videoGroup.destroy()
                    Testimonials.showTestimonials(
                        game,
                        outroInfo,
                        "Click on the faces to hear what some people have to say about being addicted.",
                    )
                },
                {
                    x: Scale.x(0.84),
                    y: Scale.y(0.9),
                    group: videoGroup,
                },
            )
        },
        group: videoGroup,
        fillScreen: true,
    })
}

export class TestimonialOutroInfo {
    testimonials: Array<VideoInfo>
    testimonialIntroAudio: string
    goTo?: GameState
    runOnNext?: () => void
}

export class VideoInfo {
    thumbnail: string
    video: string
    watched = false

    constructor(thumbnail: string, video: string) {
        this.thumbnail = thumbnail
        this.video = video
    }
}
